import React, { useEffect, useContext, useState } from "react";
import "./checkOutPage.css";
import OrderedItemsList from "./components/ordered-items/OrderedItemsList.jsx";
import Instructions from "./components/instructions/Instructions.jsx";
import Coupons from "./components/coupons/Coupons.jsx";
import Wallet from "./components/wallet/Wallet.jsx";
import BillDetails from "./components/bill-details/BillDetails.jsx";
import CartContext from "../../context/cart_context.js";
import RestaurentModel from "../../models/Restaurent_model";
import RestaurentFoodModel, {
  Availability,
} from "../../models/Restaurent_food_model";
import LoginSection from "./components/user-login/LoginSection";
import UserContext from "../../context/user_context.js";
import UserModel from "../../models/user_model";
import {
  calculateOriginalPrice,
  isRestCategoryAvailable,
  successToast,
  errorToast,
  getDeviceType,
} from "../../functions/mini_func.js";
import { db, firestoreDB } from "../../config/firebase_config.js";
import { ref, remove, set, update, get, off, onValue } from "firebase/database";
import { doc as firestoreDoc, setDoc } from "firebase/firestore";
import { useNavigate, useLocation } from "react-router-dom";
import { LoadingSpinner } from "../../components/mini-components/mini-components";
import CheckoutAlert from "./components/checkout-alert/CheckoutAlert";
import UpiApps from "./components/paytm-ui/UpiApps.jsx";
import PaymentAlert from "./components/paytm-ui/paymentAlert.jsx";
import { Drawer, DrawerContent } from "../../components/ui/drawer";
import { TimeSelectWheel } from "../../components/TimeSelectWheel.tsx";
import { Button } from "../../components/ui/button";
import { Clock, Calendar, Edit3, Sparkles, Edit } from "lucide-react";
import { TimeSelectWheelRestricted } from "../../components/TimeSelectWheelRestricted";
import TableCheckoutPage from "./TableCheckoutPage";

function loadRazorPay() {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    document.body.appendChild(script);
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
  });
}

const date = () => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

function time() {
  const now = new Date();
  const hour = _twoDigitFormat(now.getHours());
  const minute =
    _twoDigitFormat(now.getMinutes()).length == 1 ||
    _twoDigitFormat(now.getMinutes()).length == 0
      ? "00"
      : _twoDigitFormat(now.getMinutes());
  const second =
    _twoDigitFormat(now.getSeconds()).length == 1 ||
    _twoDigitFormat(now.getSeconds()).length == 0
      ? "00"
      : _twoDigitFormat(now.getSeconds());
  const amOrPm = now.getHours() < 12 ? "AM" : "PM";
  return `${hour}:${minute}:${second} ${amOrPm}`;
}

function _twoDigitFormat(number) {
  return number.toString().padStart(2, "0");
}

const CheckOutPage = () => {
  const {
    selectedRest,
    setSelectedRest,
    setCartItems,
    setSelectedfoodItemList,
    selectedfoodItemList,
    couponAmount,
    cartItems,
    payFromWallet,
    resetCart,
    instructionsRef,
    selectedCoupon,
  } = useContext(CartContext);
  const { userInfo, setUserInfo } = useContext(UserContext);
  const navigate = useNavigate();
  const [startLoading, setStartLoading] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const storeType = queryParams.get("storeType");
  const scheduledDate = queryParams.get("date");
  const scheduledTime = queryParams.get("time");
  const tableId = queryParams.get("tableId");
  const tableNo = queryParams.get("tableNo");
  const [isPaytmGtw, setisPaytmGtw] = useState(null);
  const [showPayDialog, setShowPayDialog] = useState(false);
  const [isTimeDrawerOpen, setIsTimeDrawerOpen] = useState(false);
  const [newTime, setNewTime] = useState(scheduledTime || "");

  const findGtwFn = async () => {
    const payRef = ref(db, "/PaymentGateway/8886666847/paymentGateway");
    const dataSnap = await get(payRef);
    const data = dataSnap.val();
    console.log(data);
    if (data === "Paytm") {
      setisPaytmGtw(true);
    } else {
      setisPaytmGtw(false);
    }
  };

  function getOrderId() {
    const time = new Date();
    const day = time.getDate();
    const hour = time.getHours();
    const minute = time.getMinutes();
    const second = time.getSeconds();

    return `#G${userInfo.phoneNo.substring(6)}${day}${hour}${minute}${second}`;
  }

  const retriveOrderData = () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    const razorOrderId = localStorage.getItem("razorOrderId");

    setTimeout(() => {
      successToast(
        "Payment Status",
        "Please wait while we process your transaction. If you haven't paid, you can ignore this message",
      );
    }, 0.5);

    const dabaseRef = ref(
      db,
      `TrackPayments/${userData.phoneNo}/${razorOrderId}`,
    );
    get(dabaseRef)
      .then((snapshot) => {
        console.log(snapshot);
        const data = snapshot.val();
        console.log(data);
        const orderRef = ref(
          db,
          `TrackPayments/${userData.phoneNo}/${razorOrderId}`,
        );
        if (data.status == "payment.captured") {
          setStartLoading(false);
          navigate(`/orderpage?orderID=${data.dbID}`, { replace: true });
          resetCart();
        } else if (data.status == "payment.failed") {
          setStartLoading(false);
          errorToast(
            "Transaction failed",
            "Payment failed or dismissed . please try again",
          );
          localStorage.removeItem("razorOrderId");
        } else if (data.status == "init") {
          const listeningDurationInMilliseconds = 5 * 60 * 1000;
          const currentTime = Date.now();
          const timeDifferenceInSeconds = Math.floor(
            (currentTime - parseFloat(razorOrderId)) / 1000,
          );

          if (timeDifferenceInSeconds < 300) {
            const timer = setTimeout(() => {
              const listener = onValue(orderRef, (snapshot) => {
                const data = snapshot.val();
                if (data && data.status === "payment.captured") {
                  navigate(`/orderpage?orderID=${data.dbID}`, {
                    replace: true,
                  });
                  resetCart();
                  setStartLoading(false);
                } else if (data && data.status === "payment.failed") {
                  errorToast(
                    "Transaction failed",
                    "Payment failed or dismissed. Please try again",
                  );
                  localStorage.removeItem("razorOrderId");
                  setStartLoading(false);
                  // remove(orderRef);
                }
                console.log(data);
                if (listener != null) {
                  off(orderRef, "value", listener);
                }
                clearTimeout(timer);
                // remove(orderRef);
              });

              setTimeout(() => {
                if (listener != null) {
                  off(orderRef, "value", listener);
                }
              }, listeningDurationInMilliseconds - timeDifferenceInSeconds);
            }, listeningDurationInMilliseconds - timeDifferenceInSeconds);
          } else {
            localStorage.removeItem("razorOrderId");
            // remove(orderRef);
            setStartLoading(false);
          }
        } else {
          localStorage.removeItem("razorOrderId");
          // remove(orderRef);
          setStartLoading(false);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    console.log("initalsing function of init");
    const savedRestData = localStorage.getItem("selected-rest");
    const savedCartItemsData = localStorage.getItem("cart-items");
    const savedCartListData = localStorage.getItem("cart-list");
    const userData = localStorage.getItem("user");
    const razorOrderId = localStorage.getItem("razorOrderId");

    const initalizeData = async () => {
      if (savedCartItemsData == null || savedCartListData == null) {
        navigate(-1);
        return;
      }

      if (
        savedCartListData != null &&
        savedCartItemsData != null &&
        savedCartListData != null
      ) {
        console.log("enter the dragon");
        console.log(
          "savedRestData",
          savedRestData,
          "savedCartItemsData",
          savedCartItemsData,
          "savedCartListData",
          savedCartListData,
        );
        const savedRest = JSON.parse(savedRestData);
        setSelectedRest(RestaurentModel.fromJson(savedRest.dbID, savedRest));
        setCartItems(JSON.parse(savedCartItemsData));
        const itemsListData = JSON.parse(savedCartListData);
        const itemsList = itemsListData.map((data) =>
          RestaurentFoodModel.fromJson(data.dbID, data),
        );
        console.log(itemsList);
        setSelectedfoodItemList(itemsList);
        if (userData != null) {
          setUserInfo(UserModel.fromJson(JSON.parse(userData)));
        }

        if (razorOrderId != null && userData != null) {
          console.log(
            "vinpistunda ...... kanipistunda yetti....................",
          );
          retriveOrderData();
        }
      }
      await findGtwFn();
    };

    initalizeData();
  }, []);

  const gstAmount = () => {
    var total = 0;

    if (selectedfoodItemList.length != 0) {
      Object.entries(cartItems).forEach(([key, value]) => {
        const item = selectedfoodItemList.find((item) => item.dbID == key);
        if (item.gst == Availability.YES)
          total =
            total +
            calculateOriginalPrice(item.discount, parseFloat(item.price)) *
              value;
      });
    }

    return Math.round(total * 0.05);
  };

  const payAmount = () => {
    var total = 0;

    if (selectedfoodItemList.length != 0) {
      Object.entries(cartItems).forEach(([key, value]) => {
        const item = selectedfoodItemList.find((item) => item.dbID == key);
        total =
          total +
          calculateOriginalPrice(item.discount, parseFloat(item.price)) * value;
      });
    }

    return total + gstAmount() - couponAmount;
  };

  const finalAmount = () => {
    var total = 0;

    if (selectedfoodItemList.length != 0) {
      Object.entries(cartItems).forEach(([key, value]) => {
        const item = selectedfoodItemList.find((item) => item.dbID == key);
        total =
          total +
          calculateOriginalPrice(item.discount, parseFloat(item.price)) * value;
      });
    }

    if (userInfo != null) {
      let walletAmount = payFromWallet ? parseFloat(userInfo.balance) : 0;
      return total + gstAmount() - couponAmount - walletAmount;
    } else {
      return total + gstAmount() - couponAmount;
    }
  };

  const foodTotal = () => {
    var total = 0;

    if (selectedfoodItemList.length != 0) {
      Object.entries(cartItems).forEach(([key, value]) => {
        const item = selectedfoodItemList.find((item) => item.dbID == key);
        total =
          total +
          calculateOriginalPrice(item.discount, parseFloat(item.price)) * value;
      });
    }

    return total;
  };

  function initializePaytmCheckout(orderId, token, amount, paymentHandler) {
    return new Promise((resolve, reject) => {
      const onScriptLoad = () => {
        const config = {
          root: "",
          flow: "DEFAULT",
          redirect: false,
          data: {
            orderId: orderId.split("#")[1] /* update order id */,
            token: token /* update token value */,
            tokenType: "TXN_TOKEN",
            amount: amount,
            userDetail: {
              mobileNumber: userInfo.phoneNo,
              name: userInfo.firstName,
            },
            merchant: {
              mid: "bDPTCj55212214623831",
              redirect: false,
              hidePaytmBranding: true,
            },
          },
          handler: {
            transactionStatus: function (paymentStatus) {
              console.log("paymentStatus => ", paymentStatus);
              // navigate("/confirm" , {replace:true});
            },
            notifyMerchant: function (eventName, data) {
              paymentHandler();
              console.log("notifyMerchant handler function called");
              console.log("eventName => ", eventName);
              console.log("data => ", data);
              // navigate("/confirm" , {replace:true})
            },
          },
        };

        if (window.Paytm && window.Paytm.CheckoutJS) {
          window.Paytm.CheckoutJS.onLoad(function excecuteAfterCompleteLoad() {
            // initialize configuration using init method
            window.Paytm.CheckoutJS.init(config)
              .then(function onSuccess() {
                // after successfully update configuration invoke checkoutjs
                window.Paytm.CheckoutJS.invoke();
                resolve();
              })
              .catch(function onError(error) {
                console.log("error => ", error);
                reject(error);
              });
          });
        }
      };

      const script = document.createElement("script");
      script.src =
        "https://securegw.paytm.in/merchantpgpui/checkoutjs/merchants/bDPTCj55212214623831.js";
      script.async = true;
      script.onload = onScriptLoad;
      document.body.appendChild(script);
    });
  }

  const displayRazorpay = async () => {
    const res = await loadRazorPay();
    if (!res) {
      errorToast(
        "Some thing went wrong !!!",
        "Unable to open payment gateway. please check your internet connection",
      );
      setStartLoading(false);
      return;
    }

    const orderId = getOrderId();
    const response = await fetch(
      `https://us-central1-thediningapp-a976c.cloudfunctions.net/getOrderId?amount=${
        finalAmount() * 100
      }&receipt=${orderId}`,
    );
    const data = await response.json();
    console.log(data);
    localStorage.setItem("razorOrderId", data.id);
    console.log("<--------->", data.id, "<----------->");

    const options = {
      key: "rzp_live_gJ4C2urCIxqFqd",
      amount: data.amount,
      order_id: data.id,
      currency: "INR",
      name: "Flashpe",
      description: "web payments",
      timeout: 300,
      prefill: {
        name: userInfo.name,
        email: userInfo.email,
        contact: userInfo.phoneNo,
      },
      notes: {
        device: "Web",
      },

      handler: function (response) {
        console.log(response);
        retriveOrderData();
      },
      modal: {
        ondismiss: function () {
          setStartLoading(false);
          console.log("Payment failed or dismissed");
          errorToast(
            "Transaction failed",
            "Payment failed or dismissed . please try again",
          );
          const transID = localStorage.getItem("razorOrderId");
          if (transID != null) {
            try {
              const confirmPayRef = ref(
                db,
                `TrackPayments/${userInfo.phoneNo}/${transID}`,
              );
              remove(confirmPayRef);
              localStorage.removeItem("razorOrderId");
            } catch (e) {
              setStartLoading(false);
              errorToast("some thing went wrong!!!", e.toString());
              localStorage.removeItem("razorOrderId");
            }
          }
        },
      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
    placeOrder(true, orderId);
  };

  const paymentHandler = () => {
    setStartLoading(false);
    console.log("Payment failed or dismissed");
    errorToast(
      "Transaction failed",
      "Payment failed or dismissed . please try again",
    );
    const transID = localStorage.getItem("razorOrderId");
    if (transID != null) {
      try {
        const confirmPayRef = ref(
          db,
          `TrackPayments/${userInfo.phoneNo}/${transID}`,
        );
        remove(confirmPayRef);
        localStorage.removeItem("razorOrderId");
      } catch (e) {
        setStartLoading(false);
        errorToast("some thing went wrong!!!", e.toString());
        localStorage.removeItem("razorOrderId");
      }
    }
  };

  const displayPaytm = async (isIos, appName) => {
    let deepLinkUrl = "";
    try {
      const orderId = getOrderId();
      const amount = finalAmount().toString();

      const fetchOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          amount: amount,
          appType: isIos ? "WAP" : "WEB",
          orderID: orderId,
          userID: userInfo.phoneNo,
          isUpiIntent: isIos ? true : undefined,
        }),
      };
      const response = await fetch(
        "https://us-central1-thediningapp-a976c.cloudfunctions.net/initPaytm",
        fetchOptions,
      );
      const data = await response.json();
      console.log(data);
      localStorage.setItem("razorOrderId", orderId.split("#")[1]);
      placeOrder(true, orderId, orderId.split("#")[1]);

      if (isIos) {
        const respOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            transToken: data.body.txnToken,
            orderID: orderId.split("#")[1],
            osType: "IOS",
            pspApp: appName,
          }),
        };
        const deepLinkResponse = await fetch(
          "https://us-central1-thediningapp-a976c.cloudfunctions.net/paytmUPIIntentInit",
          respOptions,
        );
        const deepLinkData = await deepLinkResponse.json();
        console.log(deepLinkData);
        console.log(deepLinkData.body.deepLinkInfo.deepLink, deepLinkData.body);
        deepLinkUrl = deepLinkData.body.deepLinkInfo.deepLink;
      }

      if (!isIos) {
        try {
          await initializePaytmCheckout(
            orderId,
            data.body.txnToken,
            amount,
            paymentHandler,
          );
          setStartLoading(false);
          return;
        } catch (e) {
          errorToast(
            "Some thing went wrong !!!",
            "Unable to open payment gateway. please check your internet connection",
          );
          return;
        }
      }
      return deepLinkUrl;
    } catch (e) {
      console.log(e);
      errorToast("Some thing went wrong !!!", e.toString());
    }
  };

  const getPayUrl = async () => {
    try {
      // if(!(await checkCartData())){
      //     return ;
      // }

      // setInitPayu(true);
      const amount = finalAmount().toString();
      const productInfo = pickupItems();
      const firstName =
        userInfo.firstName.length > 1 ? userInfo.firstName : "Flashpe";
      const email =
        userInfo.emailId.length > 5
          ? userInfo.emailId
          : "admin@thediningapp.com";
      const phone = userInfo.phoneNo;
      const txnId = Date.now().toString();

      // const response =  await fetch("https://payuhashfunction-jdoxig6lva-uc.a.run.app", {
      const response = await fetch(
        // "http://127.0.0.1:5001/thediningapp-a976c/us-central1/payuHashFunction",
        "https://payuhashfunction-jdoxig6lva-uc.a.run.app",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            amount,
            productInfo,
            firstName,
            email,
            phone,
            txnId,
            paymentType: "ORDER",
            storeId: selectedRest?.dbID || "",
          }),
        },
      );

      console.log({ amount, productInfo, firstName, email, phone, txnId });

      if (response.ok) {
        const data = await response.json();
        console.log("PayU response data received");
        placeOrder(true, txnId, txnId);

        // the Cloud Function returns a self-submitting form
        document.open();
        document.write(data.html);
        document.close();
      } else {
        errorToast(
          "Transaction failed",
          "unable to transaction right now. please try later",
        );
      }
      // setInitPayu(false);
      setStartLoading(false);
    } catch (e) {
      console.log(e);
      setStartLoading(false);

      // setInitPayu(false);
    }
  };

  const PayuButton = () => {
    const amount = finalAmount();
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {amount > 0 ? (
          <button
            className="payment-button-container"
            // className='payU-button-container'
            onClick={() => getPayUrl()}
          >{`Proceed to pay \u{20B9}${amount}`}</button>
        ) : (
          <></>
        )}
      </div>
    );
  };

  const walletTransaction = async () => {
    try {
      const trans = {
        additionalAmount: "0",
        amount: `${payAmount()}`,
        date: date(),
        dateTime: `${time()} ${date()}`,
        description: "",
        status: "0",
        time: time(),
        transactionType: "Order Payment",
      };
      console.log(trans);
      const databaseRef = ref(
        db,
        `${userInfo.phoneNo}_TransactionHistorys/${Date.now()}`,
      );
      await set(databaseRef, trans);
      const userRef = ref(db, `Users/${userInfo.phoneNo}`);
      await update(userRef, {
        balance: parseInt(
          parseFloat(userInfo.balance) - payAmount(),
        ).toString(),
      });
      successToast(
        "Transaction succesful",
        "payment completed succesfully , Initating  Order Placement",
      );
      await placeOrder(false, getOrderId());
    } catch (e) {
      setStartLoading(false);
      errorToast("Transaction Failed", e.toString());
    }
  };

  const toPetPoojaRest = async (orderId) => {
    const petPoojaData = {
      //  "app_key": "mai8jvwd6ouykne7b2p4qz910ct3rsfg",
      //  "app_secret": "c0ceb0508d5932b34147354741dc7a06bf342298",
      //  "access_token": "54d3a5b11fcc190dab81485a95a9114f06787874",
      app_key: "3165fgdqe7n0kycaouw8btrsv9zjm42h", // production
      app_secret: "49b36d5f183efe63b932a9e3eabf7bbba25542e2",
      access_token: "8b4d2d077d127d495d03095ec1eeaee0dc12ff94",
      orderinfo: {
        OrderInfo: {
          Restaurant: {
            details: {
              res_name: selectedRest.name,
              address: selectedRest.address,
              contact_information: selectedRest.restaurantOwnerNo,
              restID: selectedRest.petPoojaRestaurantId,
            },
          },
          Customer: {
            details: {
              email: userInfo.emailId,
              name: userInfo.firstName,
              address: "",
              phone: userInfo.phoneNo,
              latitude: "",
              longitude: "",
            },
          },
          Order: {
            details: {
              orderID: orderId,
              preorder_date: new Date().toISOString().substring(0, 10),
              service_charge: "0",
              order_type: "H",
              payment_type: "ONLINE",
              table_no: tableNo || "",
              table_id: tableId || "",
              no_of_persons: "0",
              total: foodTotal(),
              description: instructionsRef.current.value,
              created_on: new Date().toString(),
              enable_delivery: 0,
              min_prep_time: 20,
              dc_tax_amount: "0",
              callback_url:
                "https://asia-south1-thediningapp-a976c.cloudfunctions.net/api",
              dc_gst_details: [
                {
                  gst_liable: "vendor",
                  amount: "2.5",
                },
                {
                  gst_liable: "restaurant",
                  amount: "0",
                },
              ],
            },
          },
          OrderItem: {
            details: selectedfoodItemList.map((item) => {
              return {
                id: item.petPoojaItemId,
                name: item.name,
                item_tax: [],
                item_discount: item.discount,
                price: item.price,
                final_price: item.settlementPrice,
                quantity: cartItems[item.dbID].toString(),
                description: item.description,
                AddonItem: { details: [] },
              };
            }),
          },
        },
        udid: Date.now().toString(),
        device_type: "Web",
      },
    };

    console.log(petPoojaData);

    fetch("https://pponlineordercb.petpooja.com/save_order", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // Additional headers if needed
      },
      body: JSON.stringify(petPoojaData), // The data to send in the request body
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        // Handle the response data
      })
      .catch((error) => {
        console.log(error);
        // Handle any errors
      });
  };

  const pickupItems = () => {
    let items = "Pickup items : ";
    selectedfoodItemList.forEach((item) => {
      items = `${items}${item.name} (${cartItems[item.dbID]}), `;
    });
    return items;
  };

  const placeOrder = async (isRazorPayTrans, productOrderId, orderID) => {
    const day = () => {
      const date = new Date();
      const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      return dayNames[date.getDay()];
    };

    const totalOrderedItems = () => {
      var totalItems = 0;

      if (selectedfoodItemList.length != 0) {
        Object.entries(cartItems).forEach(([key, value]) => {
          totalItems = totalItems + value;
        });
      }
      return totalItems;
    };

    const getorderOTp = () => {
      const currentDate = new Date();
      const minute = String(currentDate.getMinutes()).padStart(2, "0");
      const second = String(currentDate.getSeconds()).padStart(2, "0");
      return `${userInfo.phoneNo.slice(-2)}${minute}${second}`;
    };

    const foodList = selectedfoodItemList.map((item) => {
      const foodItem = item.toJson();
      return {
        captainName: userInfo.firstName,
        categoryName: foodItem.categoryName,
        department: foodItem.department,
        discount: foodItem.discount,
        gst: foodItem.gst,
        happyHour: foodItem.happyHour,
        image: foodItem.image,
        itemType: foodItem.type,
        kitchen: foodItem.kitchen,
        kitchenId: foodItem.kitchenId || "",
        onFieldPrice: foodItem.onFieldPrice,
        particular: foodItem.particular,
        petPoojaExternalId: foodItem.petPoojaExternalId,
        petPoojaItemId: foodItem.petPoojaItemId,
        price: foodItem.price,
        productId: foodItem.productId,
        productName: foodItem.name,
        quantity: `${cartItems[item.dbID]}`,
        settlementPrice: calculateOriginalPrice(
          parseFloat(
            foodItem.discount.toString().length == 0 ? "0" : foodItem.discount,
          ),
          parseFloat(foodItem.price),
        ).toString(),
        type: "Food",
        userPhone: userInfo.phoneNo,
      };
    });

    const isWithinPreOrderTime = () => {
      if (selectedRest.preOrder) {
        const currentTime = new Date();
        const currentHours = currentTime.getHours();

        const fromHours = selectedRest.preOrder.from;
        const toHours = selectedRest.preOrder.to;

        console.log({
          currentHours,
          fromHours,
          toHours,
        });

        // Handle case where time range crosses midnight
        if (fromHours > toHours) {
          return currentHours >= fromHours || currentHours <= toHours;
        }

        return currentHours >= fromHours && currentHours <= toHours;
      }
      return false;
    };

    console.log(
      `<------ main store ra ayya -------  ${storeType} -------------->`,
    );
    const order = {
      address: "",
      cardAmount: "",
      cashAmount: "",
      cashback: "No",
      comments: instructionsRef.current.value,
      customerNo: userInfo.phoneNo,
      date: date(),
      day: day(),
      dineOutAmount: "",
      discountType: selectedCoupon != null ? selectedCoupon.couponCode : "",
      dropAddress1: "",
      dropAddress2: "",
      dropApartmentAddress: "",
      dropCity: "",
      dropCountry: "",
      dropLandmark: "",
      dropLat: "",
      dropLng: "",
      dropPinCode: "",
      dropState: "",
      food: foodList,
      foodTotal: foodTotal().toString(), //////
      gstNo: selectedRest.gstNo,
      holdAmount: "",
      hotelId: selectedRest.dbID,
      hotelRestName: selectedRest.name,
      kot: "",
      latLng: "",
      littleAppAmount: "",
      magicPinAmount: "",
      isPreOrder: isWithinPreOrderTime(),
      month:
        (new Date().getMonth() + 1).toString().length == 1
          ? `0${new Date().getMonth() + 1}`
          : (new Date().getMonth() + 1).toString(),
      name: userInfo.firstName,
      nc: "",
      ncType: "",
      nearBuyAmount: "",
      offerDiscount: couponAmount.toString(),
      orderBazaar: "No",
      orderFrom: "User",
      orderId: productOrderId,
      orderPickUpItems: pickupItems(),
      orderPlatform: "Web",
      orderTaskId: "",
      // "orderType":  selectedRest.storeType === StoreType.ORGANIZATION ? "Priority" : selectedRest.storeType === StoreType.RESTAURANT ? "DineInn" : "DineInn" ,
      // "orderType": ( storeType === "Cafeteria" || storeType === "Organization"  ) ? "Priority" : storeType === "Restaurant" ? "DineInn" : "Priority" ,
      orderType: "Priority",
      paymentMethod: "Online",
      paymentMethods: "",
      paymentOtp: "",
      paymentState: "Paid",
      phone: userInfo.phoneNo,
      petPoojaRestaurantId: selectedRest.petPoojaRestaurantId,
      pickUpAddress1: selectedRest.addressOne,
      pickUpAddress2: selectedRest.addressTwo,
      pickUpApartmentAddress: selectedRest.address,
      pickUpCity: selectedRest.city,
      pickUpCountry: selectedRest.country,
      pickUpLandmark: selectedRest.area,
      pickUpLat: selectedRest.storeLat,
      pickUpLng: selectedRest.storeLong,
      pickUpPinCode: selectedRest.pincode,
      pickUpState: selectedRest.state,
      rateComments: "",
      rateValue: "",
      razorPayPaymentId: "",
      restAddress: selectedRest.address,
      restName: selectedRest.name,
      restOrderType: "Online",
      restOwnerNo: selectedRest.restaurantOwnerNo,
      restaurantId: selectedRest.dbID,
      restaurantOwner: selectedRest.restaurantBarNo,
      serviceCharge: "No",
      status: "0",
      tableNo: tableNo || "",
      tableId: tableId || "",
      time: time(),
      timeLine:
        new Date().getHours().toString().length == 1
          ? `0${new Date().getHours()}`
          : new Date().getHours().toString(),
      total: payAmount().toString(),
      totalQnty: totalOrderedItems().toString(),
      upiAmount: "",
      year: new Date().getFullYear().toString(),
      foodGst: Math.round(foodTotal() * 0.05).toString(),
      offerType: "food",
      promoDiscount: "",
      serviceTax: "0",
      tipAmount: "0",
      walletDiscount: "",
      orderOTP: getorderOTp(),
      orderReview: "No",
      pickupDate: scheduledDate || "",
      pickupTime: scheduledTime || "",
    };

    console.log(
      `<------- -....  order type ra ayyyyaa......   ${order.orderType}   ....- -------->`,
    );

    if (isRazorPayTrans) {
      const timeID = localStorage.getItem("razorOrderId");
      try {
        const confirmPayRef = ref(
          db,
          `TrackPayments/${userInfo.phoneNo}/${orderID ? orderID : timeID}`,
        );
        await set(confirmPayRef, {
          status: "init",
          wallet: payFromWallet,
          walletAmount: userInfo.balance,
          order: order,
          device: "WEB",
          created_at: new Date().toISOString().split("T")[0],
          order_id: orderID ? orderID : timeID,
          time: time(),
        });
      } catch (e) {
        setStartLoading(false);
        errorToast("some thing went wrong!!!", e.toString());
      }
    } else {
      try {
        const time = Date.now();
        const confirmPayRef = ref(db, `ConfirmPayment/${time}`);
        await set(confirmPayRef, order);

        const userPayRef = ref(
          db,
          `${userInfo.phoneNo}_ConfirmPayment/${time}`,
        );
        await set(userPayRef, order);

        const restPayRef = ref(
          db,
          `${selectedRest.restaurantBarNo}_ConfirmPayment/${time}`
        );
        await set(restPayRef, order);

        if (tableId) {
          try {
            const firestoreOrderRef = firestoreDoc(firestoreDB, "orders", time.toString());
            await setDoc(firestoreOrderRef, order);
          } catch (fsError) {
            console.error("Error saving to Firestore orders:", fsError);
          }
        }

        if (
          selectedRest.petPoojaRestaurantId != null &&
          selectedRest.petPoojaRestaurantId.length > 1
        ) {
          await toPetPoojaRest(productOrderId);
        }

        setStartLoading(false);
        navigate(`/orderpage?orderID=${time}`, { replace: true });
        resetCart();
      } catch (e) {
        errorToast("Ooops ... something went wrong", e.toString());
        setStartLoading(false);
      }
    }
  };

  const checkCartData = async () => {
    let itemsAvail = true;
    try {
      for (let i = 0; i < selectedfoodItemList.length; i++) {
        const item = selectedfoodItemList[i];
        console.log(
          `<--------- items id :  ${item.restaurantId}_${item.categoryName}/${item.dbID} ------>`,
        );
        let dbRef = ref(
          db,
          `${item.restaurantId}_${item.categoryName}/${item.dbID}`,
        );
        const snapshot = await get(dbRef);
        if (snapshot.exists()) {
          const restItemModel = snapshot.val();
          console.log(
            `<--------------  getting the new data rest  ${restItemModel} --- ${isRestCategoryAvailable(
              restItemModel,
            )} --- ${restItemModel.availability}  ------------->`,
          );
          if (
            !(
              isRestCategoryAvailable(restItemModel) &&
              restItemModel.visibility == "Yes"
            )
          ) {
            errorToast(
              "item Unavailable",
              `${restItemModel.name} is currently unavailable`,
            );
            itemsAvail = false;
            break;
          }
        } else {
          errorToast(
            "item Unavailable",
            `${item.name} is currently unavailable`,
          );
          itemsAvail = false;
        }
      }
    } catch (e) {
      errorToast(
        "something went wrong",
        "Ooops.. Unable to verify items . please try later",
      );
      itemsAvail = false;
    }
    return itemsAvail;
  };

  const paymentButtonFunc = async () => {
    if (userInfo != null) {
      setStartLoading(true);
      //  navigate(`/orderpage?orderID=1701614695161`);

      if (await checkCartData()) {
        if (finalAmount() > 0) {
          const payRef = ref(db, "/PaymentGateway/8886666847/paymentGateway");
          const dataSnap = await get(payRef);
          const data = dataSnap.val();
          console.log(data);
          if (data === "Paytm") {
            displayPaytm();
          } else if (data == "Payu") {
            getPayUrl();
          } else {
            displayRazorpay();
          }
        } else {
          walletTransaction();
        }
      } else {
        setStartLoading(false);
      }
    } else {
      errorToast(
        "Authentication Required",
        "Please log in to proceed to payment and enjoy exclusive discounts.",
      );
    }
  };

  const PaymentButton = () => {
    return (
      <button
        className="payment-button-container"
        onClick={() => paymentButtonFunc()}
      >
        {finalAmount() > 0 ? (
          <>
            Proceed to pay {"\u{20B9}"}
            {finalAmount()}
          </>
        ) : (
          <> Pay through wallet </>
        )}
      </button>
    );
  };

  const getUpiIntent = async (appName) => {
    if (userInfo != null) {
      setStartLoading(true);
      if (await checkCartData()) {
        const deepLinkUrl = await displayPaytm(true, appName);
        window.location.href = deepLinkUrl;
        setTimeout(() => {
          setStartLoading(false);
          setShowPayDialog(true);
        }, 3000);
      } else {
        setStartLoading(false);
      }
    } else {
      errorToast(
        "Authentication Required",
        "Please log in to proceed to payment and enjoy exclusive discounts.",
      );
    }
  };

  return (
    selectedRest != null && (
      <div className="checkout-page-container">
        <div className="checkout-app-bar">{selectedRest.name}</div>

        {isPaytmGtw == null ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
              width: "100%",
            }}
          >
            <LoadingSpinner />
          </div>
        ) : (
          <>
            <OrderedItemsList />
            <LoginSection />
            <Instructions />
            <Coupons />
            <Wallet />

            {/* Prebooking Indicator */}
            {scheduledTime && !scheduledDate && (
              <div
                style={{
                  background:
                    "linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #d946ef 100%)",
                  padding: "10px 12px",
                  margin: "8px 12px",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  boxShadow:
                    "0 4px 12px rgba(99, 102, 241, 0.2), 0 1px 4px rgba(0, 0, 0, 0.1)",
                  position: "relative",
                  overflow: "hidden",
                  border: "1px solid rgba(255, 255, 255, 0.15)",
                }}
              >
                {/* Animated background patterns - smaller for mobile */}
                <div
                  style={{
                    position: "absolute",
                    top: "-20px",
                    right: "-20px",
                    width: "60px",
                    height: "60px",
                    background:
                      "radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%)",
                    borderRadius: "50%",
                    pointerEvents: "none",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    bottom: "-15px",
                    left: "-15px",
                    width: "50px",
                    height: "50px",
                    background:
                      "radial-gradient(circle, rgba(255, 255, 255, 0.06) 0%, transparent 70%)",
                    borderRadius: "50%",
                    pointerEvents: "none",
                  }}
                />

                {/* Icon container - smaller for mobile */}
                <div
                  style={{
                    background:
                      "linear-gradient(135deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.15) 100%)",
                    borderRadius: "8px",
                    padding: "6px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minWidth: "32px",
                    height: "32px",
                    zIndex: 1,
                    boxShadow:
                      "0 2px 6px rgba(0, 0, 0, 0.1), inset 0 1px 2px rgba(255, 255, 255, 0.3)",
                    backdropFilter: "blur(10px)",
                  }}
                >
                  <Clock size={18} color="#ffffff" strokeWidth={2.5} />
                </div>

                {/* Content */}
                <div style={{ flex: 1, zIndex: 1, minWidth: 0 }}>
                  <div
                    style={{
                      fontWeight: "700",
                      color: "#ffffff",
                      fontSize: "13px",
                      marginBottom: "2px",
                      letterSpacing: "0.2px",
                      textShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    <Sparkles size={13} color="#ffffff" strokeWidth={2.5} />
                    <span>Prebooking</span>
                  </div>
                  <div
                    style={{
                      color: "rgba(255, 255, 255, 0.95)",
                      fontSize: "11px",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      flexWrap: "wrap",
                    }}
                  >
                    <Calendar
                      size={11}
                      color="rgba(255, 255, 255, 0.9)"
                      strokeWidth={2.5}
                    />
                    <span style={{ fontWeight: "500" }}>Pickup:</span>
                    <span
                      style={{
                        background:
                          "linear-gradient(135deg, rgba(255, 255, 255, 0.35) 0%, rgba(255, 255, 255, 0.2) 100%)",
                        padding: "2px 8px",
                        borderRadius: "6px",
                        fontWeight: "700",
                        fontSize: "11px",
                        letterSpacing: "0.3px",
                        boxShadow:
                          "0 1px 4px rgba(0, 0, 0, 0.1), inset 0 1px 2px rgba(255, 255, 255, 0.2)",
                        border: "1px solid rgba(255, 255, 255, 0.2)",
                      }}
                    >
                      {scheduledTime}
                    </span>
                  </div>
                </div>

                {/* Edit Time Button - compact for mobile */}
                <button
                  onClick={() => setIsTimeDrawerOpen(true)}
                  style={{
                    background:
                      "linear-gradient(135deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.2) 100%)",
                    border: "1px solid rgba(255, 255, 255, 0.4)",
                    borderRadius: "8px",
                    padding: "6px 10px",
                    color: "#ffffff",
                    fontSize: "11px",
                    fontWeight: "700",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    zIndex: 1,
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    boxShadow:
                      "0 1px 4px rgba(0, 0, 0, 0.15), inset 0 1px 2px rgba(255, 255, 255, 0.3)",
                    backdropFilter: "blur(10px)",
                    letterSpacing: "0.2px",
                    flexShrink: 0,
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background =
                      "linear-gradient(135deg, rgba(255, 255, 255, 0.45) 0%, rgba(255, 255, 255, 0.35) 100%)";
                    e.target.style.transform = "translateY(-1px)";
                    e.target.style.boxShadow =
                      "0 2px 6px rgba(0, 0, 0, 0.2), inset 0 1px 2px rgba(255, 255, 255, 0.4)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background =
                      "linear-gradient(135deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.2) 100%)";
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow =
                      "0 1px 4px rgba(0, 0, 0, 0.15), inset 0 1px 2px rgba(255, 255, 255, 0.3)";
                  }}
                >
                  <Edit size={16} />
                  <span>Edit</span>
                </button>
              </div>
            )}
            <BillDetails />
            {getDeviceType() === "iOS" && isPaytmGtw && finalAmount() > 0 && (
              <UpiApps
                paymentButtonFunc={paymentButtonFunc}
                getUpiIntent={getUpiIntent}
              />
            )}
            <div style={{ marginBottom: "100px" }}></div>
            {(getDeviceType() != "iOS" ||
              (getDeviceType() == "iOS" &&
                isPaytmGtw == false &&
                finalAmount() > 0) ||
              finalAmount() <= 0) && <PaymentButton />}
            {startLoading && (
              <div className="checkout-loading-bg">
                <div className="checkout-loading">
                  <LoadingSpinner />
                </div>
              </div>
            )}
            <CheckoutAlert />

            {userInfo != null && showPayDialog && (
              <PaymentAlert
                showPayDialog={showPayDialog}
                setShowPayDialog={setShowPayDialog}
                cancelPayment={paymentHandler}
              />
            )}
            {/* {
              userInfo != null && isPayu && (finalAmount() > 0 ) && <>
              {
                initPayu ?  <LoadingSpinner/>  : <PayuButton/>
              }
              </>
            } */}
          </>
        )}

        {/* Time Edit Drawer */}
        <Drawer open={isTimeDrawerOpen} onOpenChange={setIsTimeDrawerOpen}>
          <DrawerContent
            className="border-none"
            style={{
              backgroundColor: "#1a1a1a",
              // borderTop: "1px solid #333",
            }}
          >
            <div style={{ padding: "24px" }}>
              <h3
                style={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  color: "#ffffff",
                  marginBottom: "16px",
                }}
              >
                Edit Pickup Time
              </h3>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: "24px",
                }}
              >
                <TimeSelectWheelRestricted
                  onChange={setNewTime}
                  initialValue={scheduledTime || ""}
                />
              </div>
              <Button
                onClick={() => {
                  // Update URL with new time
                  const currentParams = new URLSearchParams(location.search);
                  currentParams.set("time", newTime);
                  navigate(`${location.pathname}?${currentParams.toString()}`, {
                    replace: true,
                  });
                  setIsTimeDrawerOpen(false);
                  successToast(
                    "Time Updated",
                    `Pickup time changed to ${newTime}`,
                  );
                }}
                style={{
                  width: "100%",
                  backgroundColor: "#6366f1",
                  color: "#ffffff",
                  fontWeight: "600",
                  padding: "16px",
                  borderRadius: "12px",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "16px",
                }}
              >
                Confirm Time
              </Button>
            </div>
          </DrawerContent>
        </Drawer>
      </div>
    )
  );
};

export default CheckOutPage;
